// context/ReactContext.jsx
import { createContext, useContext } from 'react';

const ReactContext = createContext(false);

export const ReactProvider = ({ children }) => (
  <ReactContext.Provider value={true}>{children}</ReactContext.Provider>
);

export const useIsReact = () => useContext(ReactContext);
